import { render, staticRenderFns } from "./InViewLazyComponent.vue?vue&type=template&id=08c4ea21&"
import script from "./InViewLazyComponent.vue?vue&type=script&lang=js&"
export * from "./InViewLazyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports